export const SITE_NAME = "Solar System Brasil";
export const SITE_URL = "https://solarsystembrasil.com.br/";
export const DEFAULT_DESCRIPTION = "Reduza sua conta de luz em até 95% com energia solar em Araçatuba e região. Instalação rápida, suporte especializado e economia garantida.";
export const DEFAULT_IMAGE = `${SITE_URL}banner.jpg`;
export const DEFAULT_KEYWORDS = [
  "energia solar",
  "solar",
  "energia solar araçatuba",
  "Araçatuba",
  "energia solar interior de São Paulo",
  "painéis solares Araçatuba",
  "energia fotovoltaica Araçatuba",
  "instalação energia solar Araçatuba",
  "economia energia solar Araçatuba",
  "Birigui energia solar",
  "Lins energia solar",
  "Penápolis energia solar",
  "orçamento energia solar",
  "Solar System Brasil",
  "Solar System Araçatuba"
];
